'use client'

import { useEffect, useMemo, useState } from 'react'
import { getUsEquitySessionState, type UsEquitySessionState } from './usEquitySession'

/**
 * The one client-side source for US equities open/closed in desk chrome: the
 * navbar clock (PageInfoPanel) and the chat panel header both read it, so they
 * cannot disagree. Status comes from getUsEquitySessionState (NYSE/NASDAQ RTH,
 * America/New_York, listed holidays).
 *
 * `now` and `session` stay null until the component mounts, so the server
 * render and the first client render match (no hydration mismatch).
 */
export function useUsEquitySession(tickMs = 1_000): {
  now: Date | null
  session: UsEquitySessionState | null
} {
  const [now, setNow] = useState<Date | null>(null)

  useEffect(() => {
    setNow(new Date())
    const timer = window.setInterval(() => setNow(new Date()), tickMs)
    return () => window.clearInterval(timer)
  }, [tickMs])

  const session = useMemo(() => (now ? getUsEquitySessionState(now) : null), [now])
  return { now, session }
}
